import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Animation } from 'myt-react-snippets';
import './index.css';
export * from './Render';
const NotificationProps = {
	template: PropTypes.exact({
		title: PropTypes.string,
		message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
		variant: PropTypes.oneOf(['success', 'primary', 'danger', 'warning']),
		dismissible: PropTypes.bool,
	}),
	animation: PropTypes.exact({
		enter: PropTypes.string.isRequired,
		exit: PropTypes.string.isRequired,
	}),
	children: PropTypes.func,
	placement: PropTypes.oneOf([
		'top-left',
		'top-right',
		'bottom-left',
		'bottom-right',
	]),
	timing: PropTypes.number,
	delay: PropTypes.number,
	cancel: PropTypes.bool,
};

const NotificationDefault = {
	template: {},
	placement: 'bottom-right',
	timing: 500,
	delay: 5000,
};

export const Notification = ({
	template: { title, message, variant = 'default', dismissible = true },
	children,
	animation,
	placement,
	timing,
	delay,
	cancel,
	...props
}) => {
	const [state, setState] = useState(true);

	const [time, setTime] = useState(null);

	let initialX;

	const startTouchHandler = (e) => {
		initialX = e.touches[0].clientX;
	};
	const endTouchHandler = (e) => {
		if (initialX && initialX < (e.touches[0] || e.changedTouches[0]).clientX) {
			setState(false);
		}
	};

	const render = (
		<div
			className='notify-template-wrapper'
			onTouchStart={startTouchHandler}
			onTouchEnd={endTouchHandler}>
			{children ? (
				children(setState)
			) : (
				<div className={`notify-template ${variant}`}>
					{!!title && <b>{title}</b>}
					<div className='message'>{message}</div>
					{dismissible && (
						<button type='button' onClick={() => setState(false)}>
							&times;
						</button>
					)}
				</div>
			)}
		</div>
	);

	React.useEffect(() => {
		cancel && setState(false);
		return () => time && clearTimeout(time);
	}, [time, cancel]);

	return (
		<Animation
			{...props}
			className={animation ? '' : 'fade-notify'}
			in={state}
			timing={timing}
			suffix={animation}
			onEntered={(target) => {
				props.onEntered && props.onEntered(target);
				delay &&
					setTime(
						setTimeout(() => {
							setState(false);
						}, delay)
					);
			}}
			onExited={(target) => {
				props.onExited && props.onExited(target);
				clearTimeout(time);
			}}>
			{render}
		</Animation>
	);
};

Notification.defaultProps = NotificationDefault;
Notification.propTypes = NotificationProps;
